var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"distributions-modal","visible":"","hide-header":"","hide-footer":""},on:{"hidden":_vm.onHidden}},[_c('DistributionsForm',{attrs:{"id":_vm.id,"initial":_vm.initial}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }